/* eslint-disable prefer-rest-params */
/* eslint-disable space-before-function-paren */
/* eslint-disable func-names */
/* eslint-disable no-unused-vars */
/* eslint-disable global-require */

let config = {};
if (process.env.PROJECT_ENV === 'prod') {
    config = require('./prod');
} else if (process.env.PROJECT_ENV === 'pre') {
    config = require('./pre');
} else if (process.env.PROJECT_ENV === 'mock') {
    config = require('./mock');
} else {
    config = require('./test');
}

const catchFn = function(fn) {
    let catchValue;
    return function() {
        if (catchValue !== undefined) {
            return catchValue;
        }

        const args = Array.prototype.slice.call(arguments, 0);
        catchValue = fn.apply(this, args);
        return catchValue;
    };
};

const getEnvironment = catchFn(() => process.env.PROJECT_ENV);

config.getEnvironment = catchFn(getEnvironment);

config.getUrl = () => {
    const url = window.location.href;
    const res = url.match(/(.*)(?=(\/[a-zA-Z]*\.html))/);
    const res2 = url.match(/(.*)(?=(\/#[a-zA-Z]*))/);
    const res3 = url.match(/(.*)(?=(\/))/);
    if (res) {
        return res[0];
    }
    if (res2) {
        return res2[0];
    }
    return res3[0];
};

module.exports = config;



// WEBPACK FOOTER //
// ./src/util/config/index.js